<script setup lang="ts">
import { computed, ref, watch } from "vue";

const model = defineModel<string[]>({ default: [], required: true });
withDefaults(defineProps<{
  name?: string;
  options: Option[];
  modelValue: string[];
}>(), {  })

const allRef = ref<HTMLInputElement | null>(null);

const allSelected = computed(() => __props.options.every((opt) => model.value.includes(opt.value || opt.text)));
const indeterminate = computed(() => !model.value.includes("Any") && model.value.length > 0);

watch(
  indeterminate,
  (to) => {
    if (allRef.value == null) return;
    allRef.value.indeterminate = to;
  },
  { immediate: true },
);

watch(
  [() => __props.options, allSelected],
  () => {
    if (model.value[0] !== "Any" || allSelected.value) return;
    allChanged(true);
  },
  { immediate: true },
);

function toggle(option: string) {
  if (model.value.includes(option)) model.value = model.value.filter((item) => !["Any", option].includes(item));
  else {
    const toAdd = [...model.value, option];
    if (toAdd.length === __props.options.length) toAdd.push("Any");

    model.value = toAdd;
  }
}

function allChanged(all: boolean) {
  model.value = all ? ["Any", ...__props.options.map((opt) => opt.value || opt.text)] : [];
}

interface Option {
  text: string;
  value: string;
}
</script>
<template>
  <div>
    <label class="tw-flex tw-items-center">
      <input
        ref="allRef"
        type="checkbox"
        :checked="allSelected"
        @change="(e) => allChanged((e.target as HTMLInputElement).checked)"
      />
      <span class="tw-ml-1">Select All</span>
    </label>
    <label v-for="(option, idx) in options" :key="option.value || idx" class="tw-flex tw-items-center">
      <input
        type="checkbox"
        :value="option.value"
        :checked="modelValue?.includes('Any') || modelValue?.includes(option.value)"
        @change="() => toggle(option.value)"
      />
      <span class="tw-ml-1" :class="`${/0/i.test(option.text) ? 'tw-italic tw-text-gray-600' : ''}`">
        {{ option.text }}
      </span>
    </label>
  </div>
</template>
